// shared-types/src/accountPaymentMethod/types.ts

import { Account } from "../account";
import { AccountIntegration } from "../accountIntegration";
import { StatusInfo } from "../common/Status";

export enum AccountPaymentMethodStatus {
  ACTIVE = 'ACTIVE', // Active
  INACTIVE = 'INACTIVE', // Disabled
}

export interface AccountPaymentMethod {
  id: string;
  accountId: string;
  accountIntegrationId?: string;
  name: string;
  description?: string;
  customerInstructions?: string;
  order: number;
  availableForWeb?: boolean;
  
  status: AccountPaymentMethodStatus;
  demo: boolean;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;

  accountIntegration?: AccountIntegration;
  account?: Account;
  statusInfo?: StatusInfo;
  typeName?: string;
}